import request from 'utils/request'

import { MCBOS010CopyRequest } from 'types/MCBOS010/MCBOS010CopyRequest'
import { MCBOS010BulkOperationRequest } from 'types/MCBOS010/MCBOS010BulkOperationRequest'
import { MCBOS010DisplayOrderRequest } from "types/MCBOS010/MCBOS010DisplayOrderRequest"
import { MCBOS010UpdateRequest } from "types/MCBOS010/MCBOS010UpdateRequest"

export const getMCBOS010InitRequest = () => {
  return request({
    url: '/MCBOS010/init',
    method: 'post',
  });
};

export const getMCBOS010Register = () =>
  request({
    url: '/MCBOS010/register',
    method: 'post',
  });

export const getMCBOS010UpdateRequest = (apiData: MCBOS010UpdateRequest) =>
  request({
    url: '/MCBOS010/updateRequest',
    method: 'post',
    data: apiData,
  });

  export const getMCBOS010CopyRequest = (apiData: MCBOS010CopyRequest) =>
  request({
    url: '/MCBOS010/copy',
    method: 'post',
    data: apiData,
  })


export const mCBOS010BulkOperationRequest = (apiData: MCBOS010BulkOperationRequest) =>
  request({
    url: '/MCBOS010/execute',
    method: 'post',
    data: apiData,
  })

export const updateDisplayOrderRequest = (apiData: MCBOS010DisplayOrderRequest) => {

  return request({
    url: '/MCBOS010/updateDisplayOrder',
    method: 'post',
    data: apiData,
  });
};